import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import React from 'react';
import { useEffect } from 'react';
import Home from "./pages/Home";
import Services from "./components/Services";
import Contact from "./components/Contact";
import ProjectDetail from "./components/ProjectDetail";
import AboutPage from "./pages/AboutPage";
import Footer from './components/Footer'; // update path as needed
import ScrollToTop from './components/ScrollToTop'; // Adjust path as needed
import BrochureViewer from './pages/BrochureV'; // adjust path as needed

import ServicesO from './pages/ServicesO';
import ContactForm from "./components/ContactForm";
import ContactPage from "./pages/ContactPage";
import AllProjects from './pages/AllProjects'; // Adjust path as needed
import FAQSection from './components/FAQSection';
import AIPage from './pages/AIPage';
import CustomSoftwarePage from './pages/CustomSoftwarePage';
import MobileDevPage from './pages/MobileDevPage';
import CloudServices from './pages/CloudServices';
import ManagedIt from './pages/ManagedIt';
import CyberSecurityPage from './pages/CyberSecurtiy';
import DigitalMarketing from "./pages/DigitalMarketing";
import Bookkeeping from "./pages/Bookkeeping";
import GraphicsDesign from "./pages/GraphicsDesign";

import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange'; // ⬅️ New

import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, // drastically improves scroll performance
    });
  }, []);

  return (
    <Router>
      <ScrollToTopOnRouteChange /> {/* ✅ Scroll on navigation */}
      <Navbar />
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<Home />} />

        {/* Standalone Pages */}
        <Route path="/About" element={<AboutPage />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />

        <Route path="/services" element={<ServicesO />} />
        <Route path="/projects" element={<AllProjects />} />
        <Route path="/faq" element={<FAQSection />} />
        <Route path="/ai" element={<AIPage />} />
        <Route path="/custom-software" element={<CustomSoftwarePage />} />
        <Route path="/mobile-app" element={<MobileDevPage />} />
        <Route path="/managed-it" element={<ManagedIt />} />

        <Route path="/cybersecurity" element={<CyberSecurityPage />} />
        <Route path="/digitalmarketing" element={<DigitalMarketing />} />
        <Route path="/bookkeeping" element={<Bookkeeping />} />

        <Route path="/graphics" element={<GraphicsDesign />} />



        <Route path="/cloud" element={<CloudServices />} />
        <Route path="/contact-us" element={<ContactPage />} />
        {/* other routes */}
        <Route path="/brochure" element={<BrochureViewer />} />
        <Route path="/ContactForm" element={<ContactForm />} />

      </Routes>

      <Footer /> {/* ✅ Place it here, outside Routes */}
      <ScrollToTop /> {/* Add this */}
    </Router>
  );
}

export default App;
